import { FC, Fragment, memo, useEffect, useMemo, useRef, useState } from 'react';
// Import Types
import type { NavigationProps } from './types';
// Import Enums
import { PageTypesEnum } from 'enums';
// Import  Components
import StepperNavigationStepItem from './StepperNavigationStepItem';
//Import Styles
import styles from './stepper.module.scss';

const StepperNavigation: FC<NavigationProps> = ({ mode, isLoading, activeStep, stepsFullConfigs, onChange }) => {
    const [stepsPendingStatusMap, setStepsPendingStatusMap] = useState<Record<string, boolean>>({});
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    // delay
    useEffect(() => {
        clearTimeout(timerRef.current!);

        timerRef.current = setTimeout(() => {
            const newStepsPendingStatusMap = stepsFullConfigs.reduce((acc, { id, isLoading, isValidating }) => {
                return {
                    ...acc,
                    [id]: isLoading || isValidating,
                };
            }, {});

            setStepsPendingStatusMap(newStepsPendingStatusMap);
        });
    }, [stepsFullConfigs, activeStep]);

    const parsedSteps = useMemo(
        () =>
            stepsFullConfigs.map(({ id, icon, label, badge, tooltipText, isMounted, isValid, isDisabled }) => ({
                id,
                icon,
                label,
                badge,
                tooltipText,
                isMounted,
                isActive: id === activeStep,
                isStepValid: mode !== PageTypesEnum.view && isValid === true,
                isStepInvalid: mode !== PageTypesEnum.view && isValid === false,
                isPending: stepsPendingStatusMap[id] || false,
                isDisabled: !!isDisabled,
            })),
        [activeStep, mode, stepsFullConfigs, stepsPendingStatusMap],
    );

    return (
        <div className={styles.navigationContainer}>
            <div className={styles.navigation}>
                {parsedSteps.map((step) => (
                    <Fragment key={step.id}>
                        <StepperNavigationStepItem isLoading={isLoading} step={step} onStepChange={onChange} />
                    </Fragment>
                ))}
            </div>
        </div>
    );
};

export default memo(StepperNavigation);
